import { AggregationTypeEnum } from "./AggregationTypeEnum";
import { CashCountViewType } from "./CashCountViewType";
import { TransCountType } from "./TransCountType";
import { WidgetFilter } from "./WidgetFilter";
import { WidgetTypesEnum } from "./WidgetTypesEnum";
import { WidgetViewConfig } from "./WidgetViewConfig";
import { WidgetViewTypesEnum } from "./WidgetViewTypesEnum";

export class DashboardWidget {
    id: number;
    dashboardId: number;

    title: string = "";
    description: string = "";
    widgetType: WidgetTypesEnum = WidgetTypesEnum.DeviceCount;

    filter: WidgetFilter = new WidgetFilter();
    viewConfig: WidgetViewConfig = new WidgetViewConfig();

    refreshTimeout: number = 0;

    positionAndSizeList: any[] = [];

    x: number;
    y: number;
    width: number;
    height: number;

    fillFromJson(data: any, breakpoint: string) {
        this.id = data.Id;
        this.dashboardId = data.DashboardId;
        this.title = data.Title;
        this.description = data.Description;
        this.widgetType = data.WidgetType;
        this.refreshTimeout = data.RefreshTimeout;

        this.filter = new WidgetFilter();
        this.filter.fillFromJson(data.Filter);

        this.viewConfig = new WidgetViewConfig();
        this.viewConfig.fillFromJson(data.ViewConfig);

        let positionAndSize = { X: 0, Y: 0, Width: 2, Height: 2 };
        if (data.Position && breakpoint) {
            data.Position.forEach((p) => {
                let obj = { breakpoint: p.Breakpoint, x: p.X, y: p.Y, width: p.Width, height: p.Height };
                this.positionAndSizeList.push(obj);
            });

            // assegno posizioni e dimensioni in base al breakpoint corrente
            if (data.Position.filter((p) => p.Breakpoint == breakpoint).length == 1) positionAndSize = data.Position.filter((p) => p.Breakpoint == breakpoint)[0];
            else if (data.Position.filter((p) => p.Breakpoint == "lg").length == 1) positionAndSize = data.Position.filter((p) => p.Breakpoint == "lg")[0];
            else {
                positionAndSize.X = 0;
                positionAndSize.Y = 0;
                positionAndSize.Width = 2;
                positionAndSize.Height = 2;
            }
        }

        this.x = positionAndSize.X;
        this.y = positionAndSize.Y;
        this.width = positionAndSize.Width;
        this.height = positionAndSize.Height;
    }

    clone(): DashboardWidget {
        let result = new DashboardWidget();

        result.id = this.id;
        result.dashboardId = this.dashboardId;
        result.title = this.title;
        result.description = this.description;
        result.widgetType = this.widgetType;
        result.filter = this.filter.clone();
        result.viewConfig = this.viewConfig.clone();
        result.refreshTimeout = this.refreshTimeout;

        // position and size
        result.positionAndSizeList = [];
        this.positionAndSizeList.forEach((p) => {
            let obj = { breakpoint: p.breakpoint, x: p.x, y: p.y, width: p.width, height: p.height };
            result.positionAndSizeList.push(obj);
        });

        result.x = this.x;
        result.y = this.y;
        result.width = this.width;
        result.height = this.height;

        return result;
    }

    getAvailableViewType(): Array<any> {
        let res = [];
        switch (this.widgetType) {
            case WidgetTypesEnum.DeviceStatus:
                if (this.viewConfig.byStatus.length == 1) {
                    res.push({
                        text: "dashboard.chart_type.number",
                        value: WidgetViewTypesEnum.Number,
                    });
                } else {
                    res.push({
                        text: "dashboard.chart_type.bar_chart",
                        value: WidgetViewTypesEnum.BarChart,
                    });
                    res.push({
                        text: "dashboard.chart_type.column_chart",
                        value: WidgetViewTypesEnum.ColumnChart,
                    });
                    res.push({
                        text: "dashboard.chart_type.line_chart",
                        value: WidgetViewTypesEnum.LineChart,
                    });
                    res.push({
                        text: "dashboard.chart_type.pie_chart",
                        value: WidgetViewTypesEnum.PieChart,
                    });
                    res.push({
                        text: "dashboard.chart_type.radar_chart",
                        value: WidgetViewTypesEnum.RadarChart,
                    });
                    res.push({
                        text: "dashboard.chart_type.table",
                        value: WidgetViewTypesEnum.Table,
                    });
                }
                break;
            case WidgetTypesEnum.UpdateStatus:
                res.push({
                    text: "dashboard.chart_type.bar_chart",
                    value: WidgetViewTypesEnum.BarChart,
                });
                res.push({
                    text: "dashboard.chart_type.column_chart",
                    value: WidgetViewTypesEnum.ColumnChart,
                });
                res.push({
                    text: "dashboard.chart_type.line_chart",
                    value: WidgetViewTypesEnum.LineChart,
                });
                res.push({
                    text: "dashboard.chart_type.pie_chart",
                    value: WidgetViewTypesEnum.PieChart,
                });
                res.push({
                    text: "dashboard.chart_type.radar_chart",
                    value: WidgetViewTypesEnum.RadarChart,
                });
                res.push({
                    text: "dashboard.chart_type.table",
                    value: WidgetViewTypesEnum.Table,
                });

                break;
            case WidgetTypesEnum.DeviceCount:
                res.push({
                    text: "dashboard.chart_type.number",
                    value: WidgetViewTypesEnum.Number,
                });
                break;
            case WidgetTypesEnum.InstallationSummary:
                res.push({
                    text: "dashboard.chart_type.device_summary_card",
                    value: WidgetViewTypesEnum.InstallationSummaryCard,
                });
                break;
            case WidgetTypesEnum.InstallationsStatusChanges:
                res.push({
                    text: "dashboard.chart_type.table",
                    value: WidgetViewTypesEnum.InstallationsStatusChangesTable,
                });
                break;
            case WidgetTypesEnum.CashCount:
                if (this.viewConfig.cashCountViewType == CashCountViewType.TotalValue) {
                    res.push({
                        text: "dashboard.chart_type.number",
                        value: WidgetViewTypesEnum.Number,
                    });
                } else {
                    res.push({
                        text: "dashboard.chart_type.bar_chart",
                        value: WidgetViewTypesEnum.BarChart,
                    });
                    res.push({
                        text: "dashboard.chart_type.column_chart",
                        value: WidgetViewTypesEnum.ColumnChart,
                    });
                    res.push({
                        text: "dashboard.chart_type.line_chart",
                        value: WidgetViewTypesEnum.LineChart,
                    });
                    res.push({
                        text: "dashboard.chart_type.table",
                        value: WidgetViewTypesEnum.Table,
                    });
                }
                break;
            case WidgetTypesEnum.CashDistribution:
                res.push({
                    text: "dashboard.chart_type.bar_chart",
                    value: WidgetViewTypesEnum.BarChart,
                });
                res.push({
                    text: "dashboard.chart_type.column_chart",
                    value: WidgetViewTypesEnum.ColumnChart,
                });
                res.push({
                    text: "dashboard.chart_type.line_chart",
                    value: WidgetViewTypesEnum.LineChart,
                });
                res.push({
                    text: "dashboard.chart_type.table",
                    value: WidgetViewTypesEnum.Table,
                });
                break;
            case WidgetTypesEnum.Transactions:
                {
                    let aggregationTypeList: Array<AggregationTypeEnum> = [
                        AggregationTypeEnum.AggregateByDayOfWeek,
                        AggregationTypeEnum.AggregateByMonth,
                        AggregationTypeEnum.AggregateByTimeOfDay,
                    ];

                    if (aggregationTypeList.includes(this.viewConfig.aggregationType)) {
                        // aggregation
                        res.push({
                            text: "dashboard.chart_type.bar_chart",
                            value: WidgetViewTypesEnum.BarChart,
                        });
                        res.push({
                            text: "dashboard.chart_type.column_chart",
                            value: WidgetViewTypesEnum.ColumnChart,
                        });
                        res.push({
                            text: "dashboard.chart_type.line_chart",
                            value: WidgetViewTypesEnum.LineChart,
                        });
                        res.push({
                            text: "dashboard.chart_type.pie_chart",
                            value: WidgetViewTypesEnum.PieChart,
                        });
                        res.push({
                            text: "dashboard.chart_type.radar_chart",
                            value: WidgetViewTypesEnum.RadarChart,
                        });
                        res.push({
                            text: "dashboard.chart_type.table",
                            value: WidgetViewTypesEnum.Table,
                        });
                        res.push({
                            text: "dashboard.chart_type.heat_grid_chart",
                            value: WidgetViewTypesEnum.HeatGridChart,
                        });

                        if (this.filter.transTypes.length > 1 || this.viewConfig.countType == TransCountType.DenominationDistribution) {
                            res.push({
                                text: "dashboard.chart_type.stacked_chart",
                                value: WidgetViewTypesEnum.StackedChart,
                            });
                        }
                    } else if (this.viewConfig.aggregationType == AggregationTypeEnum.AbsoluteValue) {
                        if (this.filter.transTypes.length == 1) {
                            res.push({
                                text: "dashboard.chart_type.number",
                                value: WidgetViewTypesEnum.Number,
                            });
                        } else {
                            res.push({
                                text: "dashboard.chart_type.bar_chart",
                                value: WidgetViewTypesEnum.BarChart,
                            });
                            res.push({
                                text: "dashboard.chart_type.column_chart",
                                value: WidgetViewTypesEnum.ColumnChart,
                            });
                            res.push({
                                text: "dashboard.chart_type.line_chart",
                                value: WidgetViewTypesEnum.LineChart,
                            });
                            res.push({
                                text: "dashboard.chart_type.pie_chart",
                                value: WidgetViewTypesEnum.PieChart,
                            });
                            res.push({
                                text: "dashboard.chart_type.radar_chart",
                                value: WidgetViewTypesEnum.RadarChart,
                            });
                            res.push({
                                text: "dashboard.chart_type.table",
                                value: WidgetViewTypesEnum.Table,
                            });
                            res.push({
                                text: "dashboard.chart_type.heat_grid_chart",
                                value: WidgetViewTypesEnum.HeatGridChart,
                            });
                        }
                    } else {
                        // timeline
                        res.push({
                            text: "dashboard.chart_type.time_line_chart",
                            value: WidgetViewTypesEnum.TimeLineChart,
                        });
                    }
                }
                break;
            default:
                break;
        }
        return res;
    }
}
